require('dotenv').config();
const crypto = require('crypto');

const ENC_KEY = process.env.REACT_APP_ENC_KEY;
const IV = process.env.REACT_APP_IV;

const encrypt = data => {
  const cipher = crypto.createCipheriv('aes-256-cbc', ENC_KEY, IV);
  let encrypted = cipher.update(data, 'utf8', 'base64');
  encrypted += cipher.final('base64');

  return encrypted;
};

const decrypt = encrypted => {
  const decipher = crypto.createDecipheriv('aes-256-cbc', ENC_KEY, IV);
  const decrypted = decipher.update(encrypted, 'base64', 'utf8');

  return (decrypted + decipher.final('utf8'));
};

const encryptArray = array => {
  let rolesEncrypt = [];

  for (let i = 0; i < array.length; i++) {
    rolesEncrypt[i] = encrypt(array[i]);
  }

  return rolesEncrypt;
};

const decryptArray = arrayEncrypted => {
  let rolesDecrypt = [];

  for (let i = 0; i < arrayEncrypted.length; i++) {
    rolesDecrypt.push(decrypt(arrayEncrypted[i]));
  }

  return rolesDecrypt;
};

module.exports = { encrypt, decrypt, encryptArray, decryptArray };
